import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import { RouteLoadingFallback } from '@/components/routes/RouteLoadingFallback';
import { RouteScrollManager } from '@/components/routes/RouteScrollManager';
import { i18n } from '@/i18n';


function SocialChannelsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/social/connect?tab=channels${search}`} replace />;
}

function LegacyOrgSignInRedirect() {
  const { search } = useLocation();
  return <Navigate to={`${ORG_SIGN_IN_PATH}${search}`} replace />;
}
import {
  LEGACY_CHOOSE_APP_PATH,
  LEGACY_MODULE_HUB_PATH,
  LEGACY_REGISTER_PATH,
  MODULE_HUB_PATH,
  ORG_SIGN_IN_PATH,
  REGISTER_PATH,
} from '@/constants/authRoutes';
import { FattahLoginPage } from '@/pages/auth/FattahLoginPage';
import { RegisterWizard } from '@/pages/auth/RegisterWizard';
import { MasterLoginPage } from '@/pages/auth/MasterLoginPage';
import { OAuthCallbackPage } from '@/pages/auth/OAuthCallbackPage';
import { ModuleLoginPage } from '@/pages/auth/ModuleLoginPage';
import { ModuleRegisterPage } from '@/pages/auth/ModuleRegisterPage';
import { ForgotPasswordPage } from '@/pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/auth/ResetPasswordPage';
import { RequiredPasswordChangePage } from '@/pages/auth/RequiredPasswordChangePage';
import { IdentityLoginPage } from '@/modules/identity/IdentityLoginPage';
import { IdentityVerifyPage } from '@/modules/identity/IdentityVerifyPage';
import { IdentityOAuthCallbackPage } from '@/modules/identity/IdentityOAuthCallbackPage';
import { LegacyPortalRedirect } from '@/modules/identity/LegacyPortalRedirect';

import { AuthShell } from '@/core/layouts/auth/AuthShell';
import { MasterAdminLayout } from '@/layouts/MasterAdminLayout';
import { OrgAdminLayout } from '@/layouts/OrgAdminLayout';
import { PosLayout } from '@/layouts/PosLayout';





import { ProtectedRoute, PublicOnlyRoute } from './ProtectedRoute';
import { ModuleScopeGuard } from './ModuleScopeGuard';
import { MODULE_SHARED_MASTER_ROUTES } from './moduleSharedMasterRoutes';
import { getAllModuleLoginRoutes, getAllModuleRegisterRoutes } from '@/config/moduleEntries';





















































































import { PortalShell } from '@/layouts/PortalShell';
import { IdentityPortalRoute, IdentityPublicRoute } from '@/routes/IdentityPortalRoute';
import { PortalScopeGuard } from '@/routes/PortalScopeGuard';

















































































import { MODULE_ENTRIES } from '@/config/moduleEntries';






























































import { LOCKED_MODULE_KEYS, moduleUsersSegment } from '@/config/moduleDefaults';
import { LegacyOrgAdminRedirect } from '@/routes/LegacyOrgAdminRedirect';
import { LegacyLockedModuleRedirect } from '@/routes/LegacyLockedModuleRedirect';
import { LegacyModuleSettingsRedirect } from '@/routes/LegacyModuleSettingsRedirect';
import { SocialSettingsLegacyRedirect } from '@/routes/SocialSettingsLegacyRedirect';
import { ApprovalLegacyDeepLinkRedirect } from '@/routes/ApprovalLegacyDeepLinkRedirect';
import { LegacyWorkRouteRedirect } from '@/routes/LegacyWorkRouteRedirect';
import { ALL_LEGACY_ORG_REDIRECTS } from '@/config/modulePathMigration';
import { LegacyModulePathRedirect } from '@/routes/LegacyModulePathRedirect';
import {
  AnalyticsPage,
  ApprovalBuilderPage,
  ApprovalMatrixPage,
  ApprovalDelegationsPage,
  ApprovalsInboxPage,
  BrandsPage,
  CatalogPage,
  CategoriesPage,
  CompaniesPage,
  ContractsPage,
  CrmCampaignsPage,
  CrmCompaniesPage,
  CrmContactsPage,
  CrmDashboardPage,
  CrmDealsPage,
  CrmGoogleOAuthCallbackPage,
  CrmLeadDetailPage,
  CrmLeadsPage,
  CrmLeadsKanbanPage,
  CrmReportsPage,
  CrmSetupPage,
  CrmTasksPage,
  CrmWorkspacePage,
  Customer360Page,
  CustomersPage,
  CustomerSupport360Page,
  DeskAutomationPage,
  DeskBoardsPage,
  DeskCannedResponsesPage,
  DeskDashboardPage,
  DeskInboxPage,
  DeskKnowledgeBasePage,
  DeskLiveChatPage,
  DeskReportsPage,
  DeskSetupPage,
  DeskTicketDetailPage,
  DeskTicketsPage,
  DeskWorkspacePage,
  DeskWorkflowDesignerPage,
  DiscountsPage,
  EmployeesPage,
  EnterpriseSetupWizard,
  ExecutiveWorkPage,
  FinanceAccountingPage,
  FinanceAdministrationWorkspacePage,
  FinanceAnalyticsPage,
  FinanceApPage,
  FinanceAssetsPage,
  FinanceAuditTrailPage,
  FinanceAutomationPage,
  FinanceBankingPage,
  FinanceBudgetsPage,
  FinanceBusinessRulesPage,
  FinanceCashForecastPage,
  FinanceCloseCenterPage,
  FinanceCollectionsCenterPage,
  FinanceCompliancePage,
  FinanceDashboardPage,
  FinanceDocumentCapturePage,
  FinanceExpensesPage,
  FinanceHealthCenterPage,
  FinanceIntegrationsPage,
  FinanceInvoicesPage,
  FinanceLedgerPage,
  FinancePayablesWorkspacePage,
  FinancePaymentsPage,
  FinanceReceivablesWorkspacePage,
  FinanceReportBuilderPage,
  FinanceReportsPage,
  FinanceRevenuePage,
  FinanceSetupPage,
  FinanceSetupWizardPage,
  FinanceTaxesPage,
  FinanceTaxWorkspacePage,
  FinanceTreasuryPage,
  FinanceWorkflowDesignerPage,
  FinanceWorkflowsPage,
  GoodsReceiptsPage,
  HeldBillsPage,
  HrAdminConfigPage,
  HrAppraisalPage,
  HrAttendancePage,
  HrCandidatePortalPage,
  HrClaimsPage,
  HrDashboardPage,
  HrDevicesPage,
  HrDocumentsPage,
  HrEmployee360Page,
  HrEssPortalPage,
  HrFeedback360Page,
  HrHolidaysPage,
  HrLeavePoliciesPage,
  HrLeavesPage,
  HrLoansPage,
  HrMasterDataPage,
  HrMssPortalPage,
  HrOnboardingPage,
  HrOrgStructurePage,
  HrPayrollPage,
  HrPublicCareersPage,
  HrRecruitmentPage,
  HrReportsPage,
  HrSetupPage,
  HrShiftsPage,
  HrTimesheetPage,
  HrOvertimePage,
  HrStatutoryPage,
  HrSuccessionPage,
  HrTrainingPage,
  HrTravelPage,
  HrWorkflowsPage,
  IdentityPortalDashboardPage,
  InventoryLedgerPage,
  InventoryPage,
  InvoicesPage,
  LeadGenAbTestsPage,
  LeadGenCampaignsPage,
  LeadGenConsentPage,
  LeadGenDashboardPage,
  LeadGenDuplicatesPage,
  LeadGenEnrichmentPage,
  LeadGenFormsPage,
  LeadGenLandingPagesPage,
  LeadGenPublicSubmitPage,
  LeadGenReportsPage,
  LeadGenRoutingPage,
  LeadGenScoringPage,
  LeadGenSourcesPage,
  LeadGenVisitorTrackingPage,
  LeadGenWebhooksPage,
  LockedModulePage,
  MarketingAcquisitionBuildersPage,
  MarketingCampaignsPage,
  MarketingCalendarPage,
  MarketingChannelsPage,
  MarketingCopilotPage,
  MarketingDashboardPage,
  MarketingEspWebhooksPage,
  MarketingJourneysPage,
  MarketingLifecyclePage,
  MarketingMediaLibraryPage,
  MarketingReportsPage,
  MarketingSegmentsPage,
  MarketingSuppressionPage,
  MarketingTemplatesPage,
  MasterAdminsPage,
  MasterCustomPlansPage,
  MasterDashboardPage,
  MasterReferenceDataPage,
  MasterSettingsPage,
  MasterUsersPage,
  ModuleWorkspaceSubscriptionPage,
  MyWorkPage,
  NotificationsCenterPage,
  OnboardingPage,
  OrganizationProfilePage,
  UserProfilePage,
  OrganizationsPage,
  OrgDashboardPage,
  PlansPage,
  ConnectPlatformPickerPage,
  PlatformConnectFlowPage,
  SetupGuideHubPage,
  SetupGuidePlatformRedirect,
  SocialExecutiveDashboardPage,
  PlatformWorkspacePage,
  SocialPlatformsHubPage,
  PortalHubPage,
  PortalSectionRouter,
  PortalVerifyPage,
  PosAnalyticsDashboard,
  PosCustomerDisplayPage,
  PosOnboardingWizard,
  PosPage,
  PosReportsPage,
  PosReturnsPage,
  PosSetupPage,
  PosShiftPage,
  ProcurementDashboardPage,
  ProcurementReportsPage,
  ProcurementSetupPage,
  ProductAlertsPage,
  ProductSelectionPage,
  ProductsPage,
  ProjectClientPortalDashboardPage,
  ProjectClientPortalLoginPage,
  ProjectClientPortalVerifyPage,
  ProjectDetailPage,
  ProjectsAutomationPage,
  ProjectsBoardsPage,
  ProjectsCalendarPage,
  ProjectsDashboardPage,
  ProjectsGanttPage,
  ProjectsIssuesPage,
  ProjectsListPage,
  ProjectsPortfolioPage,
  ProjectsReportsPage,
  ProjectsResourcesPage,
  ProjectsSetupPage,
  ProjectsSprintsPage,
  ProjectsTasksPage,
  ProjectsTimesheetsPage,
  ProjectsWorkloadPage,
  PurchaseOrdersPage,
  PurchaseRequestsPage,
  QuotationComparisonPage,
  ReportsPage,
  RfqsPage,
  RolesPage,
  CampaignsPage,
  CampaignBuilderPage,
  CampaignDetailPage,
  CampaignComparePage,
  BulkQueueMonitorPage,
  FailedQueuePage,
  ScheduledMessagesPage,
  ScheduleEditorPage,
  WhatsAppSyncCenterPage,
  WhatsAppReportsPage,
  ReportBuilderPage,
  ReportJobsPage,
  WhatsAppSettingsPage,
  WhatsAppAutomationPage,
  TeamInboxAdminPage,
  WhatsAppAuditPage,
  WhatsAppIntegrationsPage,
  WhatsAppKnowledgeBasePage,
  WhatsAppSurveysPage,
  SocialAnalyticsCenterPage,
  SocialAutomationPage,
  SocialCalendarPage,
  SocialCampaignsPage,
  SocialCommentsHubPage,
  SocialConnectionCenterPage,
  SocialCrmLeadsPage,
  SocialDashboardPage,
  SocialInboxPage,
  SocialListeningPage,
  SocialMediaLibraryPage,
  SocialPublishingCenterPage,
  SocialReviewsPage,
  SocialTeamsPage,
  SocialMessengerPage,
  SocialWorkflowBuilderPage,
  StoreProductsPage,
  StoresPage,
  SubscriptionsPage,
  SuppliersPage,
  TaxRulesPage,
  UnitsPage,
  VendorPaymentsPage,
  VendorPortalDashboardPage,
  VendorPortalVerifyPage,
  WarehouseCrossDockPage,
  WarehouseCycleCountsPage,
  WarehouseDashboardPage,
  WarehouseDockPage,
  WarehouseLaborPage,
  WarehouseOperationsPage,
  WarehousePicksPage,
  WarehouseSetupPage,
  WarehouseTransfersPage,
  WarehouseWavesPage,
  WmsMobilePage,
} from './lazyPages';
import { UnknownRouteHandler } from '@/components/routes/UnknownRouteHandler';
import { WorkspaceNotFoundHandler } from '@/components/routes/WorkspaceNotFoundHandler';
import { OrgDashboardRedirect } from '@/components/routes/OrgDashboardRedirect';
import { RouteErrorBoundary } from '@/components/errors/RouteErrorBoundary';
import {
  SettingsCategoryPage,
  SettingsPage,
  SettingsLayout,
  SettingsMasterRoute,
} from '@/modules/settings';

export function AppRoutes() {
  return (
    <BrowserRouter>
      <RouteScrollManager />
      <RouteErrorBoundary>
      <Suspense fallback={<RouteLoadingFallback />}>
      <Routes>
        <Route element={<PublicOnlyRoute />}>
          <Route element={<AuthShell />}>
            <Route path={MODULE_HUB_PATH} element={<Navigate to={ORG_SIGN_IN_PATH} replace />} />
            <Route path={LEGACY_CHOOSE_APP_PATH} element={<Navigate to={ORG_SIGN_IN_PATH} replace />} />
            <Route path={ORG_SIGN_IN_PATH} element={<FattahLoginPage />} />
            <Route path={LEGACY_MODULE_HUB_PATH} element={<LegacyOrgSignInRedirect />} />
            <Route path={REGISTER_PATH} element={<RegisterWizard />} />
            <Route path="/master/login" element={<MasterLoginPage />} />
            <Route path={LEGACY_REGISTER_PATH} element={<Navigate to={REGISTER_PATH} replace />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
            {getAllModuleLoginRoutes().map(({ path, slug }) => (
              <Route key={path} path={path} element={<ModuleLoginPage slug={slug} />} />
            ))}
            {getAllModuleRegisterRoutes().map(({ path, slug }) => (
              <Route key={path} path={path} element={<ModuleRegisterPage slug={slug} />} />
            ))}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role="any" />}>
          <Route path="/change-password" element={<RequiredPasswordChangePage />} />
        </Route>

        <Route element={<ModuleScopeGuard />}>
        <Route path="/embed/lead/:publicKey" element={<LeadGenPublicSubmitPage />} />
        <Route path="/careers/:orgId" element={<HrPublicCareersPage />} />
        <Route path="/candidate-portal/:token" element={<HrCandidatePortalPage />} />
        <Route path="/projects-portal/login" element={<ProjectClientPortalLoginPage />} />
        <Route path="/projects-portal/verify" element={<ProjectClientPortalVerifyPage />} />
        <Route path="/projects-portal/dashboard" element={<ProjectClientPortalDashboardPage />} />
        <Route path="/portal/login" element={<LegacyPortalRedirect />} />
        <Route path="/portal/verify" element={<PortalVerifyPage />} />
        <Route path="/portal/dashboard" element={<Navigate to="/portals/customer" replace />} />

        <Route element={<IdentityPublicRoute />}>
          <Route path="/identity/login" element={<IdentityLoginPage />} />
          <Route path="/identity/verify" element={<IdentityVerifyPage />} />
          <Route path="/identity/oauth/callback" element={<IdentityOAuthCallbackPage />} />
        </Route>
        <Route element={<IdentityPortalRoute />}>
          <Route path="/identity/portals" element={<PortalHubPage />} />
          <Route element={<PortalShell />}>
            <Route element={<PortalScopeGuard />}>
            <Route path="/portals/customer" element={<IdentityPortalDashboardPage />} />
            <Route path="/portals/customer/:section" element={<PortalSectionRouter />} />
            <Route path="/portals/vendor" element={<IdentityPortalDashboardPage />} />
            <Route path="/portals/vendor/:section" element={<PortalSectionRouter />} />
            <Route path="/portals/employee" element={<IdentityPortalDashboardPage />} />
            <Route path="/portals/employee/:section" element={<PortalSectionRouter />} />
            <Route path="/portals/candidate" element={<IdentityPortalDashboardPage />} />
            <Route path="/portals/candidate/:section" element={<PortalSectionRouter />} />
            <Route path="/portals/delivery" element={<IdentityPortalDashboardPage />} />
            <Route path="/portals/delivery/:section" element={<PortalSectionRouter />} />
            <Route path="/portals/partner" element={<IdentityPortalDashboardPage />} />
            <Route path="/portals/partner/:section" element={<PortalSectionRouter />} />
            </Route>
          </Route>
        </Route>

        <Route path="/pos/display/:token" element={<PosCustomerDisplayPage />} />

        <Route element={<ProtectedRoute role="master" />}>
          <Route element={<MasterAdminLayout />}>
            <Route path="/master" element={<MasterDashboardPage />} />
            <Route path="/master/users" element={<MasterUsersPage />} />
            <Route path="/master/admins" element={<MasterAdminsPage />} />
            <Route path="/master/organizations" element={<OrganizationsPage />} />
            <Route path="/master/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/master/plans" element={<PlansPage />} />
            <Route path="/master/analytics" element={<AnalyticsPage />} />
            <Route path="/master/reference-data" element={<MasterReferenceDataPage />} />
            <Route path="/master/custom-plans" element={<MasterCustomPlansPage />} />
            <Route path="/master/settings" element={<MasterSettingsPage />} />
            <Route path="/master/profile" element={<UserProfilePage />} />
            <Route path="*" element={<WorkspaceNotFoundHandler />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute role="org" />}>
          <Route path="/onboarding/products" element={<ProductSelectionPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/onboarding/pos" element={<PosOnboardingWizard />} />
          <Route path="/onboarding/enterprise" element={<EnterpriseSetupWizard />} />
          {MODULE_ENTRIES.map((entry) => (
            <Route
              key={`ws-${entry.slug}`}
              path={`/workspace/${entry.slug}`}
              element={<Navigate to={entry.homePath} replace />}
            />
          ))}
          <Route element={<OrgAdminLayout />}>
            <Route path="/org" element={<OrgDashboardRedirect />} />
            <Route path="/settings" element={<SettingsLayout />}>
              <Route index element={<SettingsPage />} />
              <Route path=":categoryKey" element={<SettingsCategoryPage />} />
              <Route path=":categoryKey/:masterKey" element={<SettingsMasterRoute />} />
            </Route>
            <Route path="/pos/dashboard" element={<OrgDashboardPage />} />
            <Route path="/work" element={<LegacyWorkRouteRedirect />} />
            <Route path="/work/executive" element={<LegacyWorkRouteRedirect />} />
            <Route path="/work/approvals" element={<ApprovalLegacyDeepLinkRedirect />} />
            <Route path="/approvals/builder" element={<LegacyWorkRouteRedirect />} />
            <Route path="/approvals/matrix" element={<LegacyWorkRouteRedirect />} />
            <Route path="/approvals/delegations" element={<LegacyWorkRouteRedirect />} />
            <Route path="/notifications" element={<LegacyWorkRouteRedirect />} />
            <Route path="/dashboard/home" element={<LegacyWorkRouteRedirect />} />
            {MODULE_ENTRIES.map((entry) => (
              <Route key={`work-${entry.slug}`}>
                <Route path={`/${entry.slug}/work`} element={<MyWorkPage />} />
                <Route path={`/${entry.slug}/work/executive`} element={<ExecutiveWorkPage />} />
                <Route path={`/${entry.slug}/approvals`} element={<ApprovalsInboxPage />} />
                <Route path={`/${entry.slug}/approvals/builder`} element={<ApprovalBuilderPage />} />
                <Route path={`/${entry.slug}/approvals/matrix`} element={<ApprovalMatrixPage />} />
                <Route path={`/${entry.slug}/approvals/delegations`} element={<ApprovalDelegationsPage />} />
                <Route path={`/${entry.slug}/notifications`} element={<NotificationsCenterPage />} />
              </Route>
            ))}
            <Route path="/dashboard/pos" element={<Navigate to="/pos/dashboard" replace />} />
            <Route path="/dashboard/crm" element={<Navigate to="/crm" replace />} />
            <Route path="/dashboard/hr" element={<Navigate to="/hr" replace />} />
            <Route path="/dashboard/finance" element={<Navigate to="/finance" replace />} />
            {MODULE_ENTRIES.map((entry) => (
              <Route key={`admin-${entry.slug}`}>
                <Route path={`/${entry.slug}/administration`} element={<Navigate to="/settings" replace />} />
                <Route path={`/${entry.slug}/profile`} element={<UserProfilePage />} />
                <Route path={`/${entry.slug}/organization`} element={<OrganizationProfilePage />} />
                <Route path={`/${entry.slug}/companies`} element={<CompaniesPage />} />
                <Route
                  path={`/${entry.slug}/${moduleUsersSegment(entry.erpModule)}`}
                  element={<EmployeesPage />}
                />
                <Route path={`/${entry.slug}/roles`} element={<RolesPage />} />
                <Route path={`/${entry.slug}/settings`} element={<LegacyModuleSettingsRedirect />} />
                <Route
                  path={`/${entry.slug}/subscription`}
                  element={<ModuleWorkspaceSubscriptionPage />}
                />
              </Route>
            ))}
            {LOCKED_MODULE_KEYS.map((moduleKey) => (
              <Route
                key={`locked-${moduleKey}`}
                path={`/${moduleKey}/locked`}
                element={<LockedModulePage />}
              />
            ))}
            <Route path="/org/locked/:moduleKey" element={<LegacyLockedModuleRedirect />} />
            <Route path="/org/profile" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/administration" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/administration/billing" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/subscription" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/workspace/settings" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/workspace/subscription" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/settings" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/employees" element={<LegacyOrgAdminRedirect />} />
            <Route path="/org/roles" element={<LegacyOrgAdminRedirect />} />
            <Route path="/pos/stores" element={<StoresPage />} />
            <Route path="/pos/products" element={<ProductsPage />} />
            <Route path="/pos/categories" element={<CategoriesPage />} />
            <Route path="/pos/brands" element={<BrandsPage />} />
            <Route path="/pos/units" element={<UnitsPage />} />
            <Route path="/pos/taxes" element={<Navigate to="/pos/tax-rules" replace />} />
            <Route path="/pos/tax-rules" element={<TaxRulesPage />} />
            <Route path="/pos/store-products" element={<StoreProductsPage />} />
            <Route path="/pos/invoices" element={<InvoicesPage />} />
            <Route path="/pos/inventory" element={<InventoryPage />} />
            <Route path="/pos/inventory/ledger" element={<InventoryLedgerPage />} />
            <Route path="/warehouse" element={<WarehouseDashboardPage />} />
            <Route path="/warehouse/operations" element={<WarehouseOperationsPage />} />
            <Route path="/warehouse/setup" element={<WarehouseSetupPage />} />
            <Route path="/warehouse/picks" element={<WarehousePicksPage />} />
            <Route path="/warehouse/transfers" element={<WarehouseTransfersPage />} />
            <Route path="/warehouse/cycle-counts" element={<WarehouseCycleCountsPage />} />
            <Route path="/warehouse/waves" element={<WarehouseWavesPage />} />
            <Route path="/warehouse/dock" element={<WarehouseDockPage />} />
            <Route path="/warehouse/cross-dock" element={<WarehouseCrossDockPage />} />
            <Route path="/warehouse/labor" element={<WarehouseLaborPage />} />
            <Route path="/pos/product-alerts" element={<ProductAlertsPage />} />
            <Route path="/pos/suppliers" element={<SuppliersPage />} />
            <Route path="/procurement" element={<ProcurementDashboardPage />} />
            <Route path="/procurement/purchase-requests" element={<PurchaseRequestsPage />} />
            <Route path="/procurement/rfqs" element={<RfqsPage />} />
            <Route path="/procurement/quotations" element={<QuotationComparisonPage />} />
            <Route path="/procurement/purchase-orders" element={<PurchaseOrdersPage />} />
            <Route path="/procurement/approvals" element={<ApprovalsInboxPage />} />
            <Route path="/procurement/goods-receipts" element={<GoodsReceiptsPage />} />
            <Route path="/procurement/vendor-bills" element={<VendorPaymentsPage />} />
            <Route path="/procurement/contracts" element={<ContractsPage />} />
            <Route path="/procurement/catalogs" element={<CatalogPage />} />
            <Route path="/procurement/reports" element={<ProcurementReportsPage />} />
            <Route path="/procurement/setup" element={<ProcurementSetupPage />} />
            <Route path="/vendor-portal/login" element={<LegacyPortalRedirect />} />
            <Route path="/vendor-portal/verify" element={<VendorPortalVerifyPage />} />
            <Route path="/vendor-portal/dashboard" element={<VendorPortalDashboardPage />} />
            <Route path="/procurement/settings" element={<Navigate to="/procurement/setup" replace />} />
            <Route path="/pos/customers" element={<CustomersPage />} />
            {MODULE_SHARED_MASTER_ROUTES.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            <Route path="/crm" element={<CrmDashboardPage />} />
            <Route path="/crm/leads" element={<CrmLeadsPage />} />
            <Route path="/crm/leads/board" element={<CrmLeadsKanbanPage />} />
            <Route path="/crm/leads/:id" element={<CrmLeadDetailPage />} />
            <Route path="/crm/contacts" element={<CrmContactsPage />} />
            <Route path="/crm/companies" element={<CrmCompaniesPage />} />
            <Route path="/crm/deals" element={<CrmDealsPage />} />
            <Route path="/crm/customers/:customerId" element={<Customer360Page />} />
            <Route path="/crm/pipelines" element={<Navigate to="/crm/setup" replace />} />
            <Route path="/crm/followups" element={<CrmWorkspacePage title={i18n.t('pages.followups.title', { ns: 'crm' })} description={i18n.t('pages.followups.description', { ns: 'crm' })} />} />
            <Route path="/crm/tasks" element={<CrmTasksPage />} />
            <Route path="/crm/campaigns" element={<CrmCampaignsPage />} />
            <Route path="/lead-gen" element={<LeadGenDashboardPage />} />
            <Route path="/lead-gen/forms" element={<LeadGenFormsPage />} />
            <Route path="/lead-gen/landing-pages" element={<LeadGenLandingPagesPage />} />
            <Route path="/lead-gen/campaigns" element={<LeadGenCampaignsPage />} />
            <Route path="/lead-gen/visitor-tracking" element={<LeadGenVisitorTrackingPage />} />
            <Route path="/lead-gen/scoring" element={<LeadGenScoringPage />} />
            <Route path="/lead-gen/routing" element={<LeadGenRoutingPage />} />
            <Route path="/lead-gen/consent" element={<LeadGenConsentPage />} />
            <Route path="/lead-gen/reports" element={<LeadGenReportsPage />} />
            <Route path="/lead-gen/sources" element={<LeadGenSourcesPage />} />
            <Route path="/lead-gen/duplicates" element={<LeadGenDuplicatesPage />} />
            <Route path="/lead-gen/ab-tests" element={<LeadGenAbTestsPage />} />
            <Route path="/lead-gen/webhooks" element={<LeadGenWebhooksPage />} />
            <Route path="/lead-gen/enrichment" element={<LeadGenEnrichmentPage />} />
            <Route path="/marketing" element={<MarketingDashboardPage />} />
            <Route path="/marketing/campaigns" element={<MarketingCampaignsPage />} />
            <Route path="/marketing/channels" element={<MarketingChannelsPage />} />
            <Route path="/marketing/calendar" element={<MarketingCalendarPage />} />
            <Route path="/marketing/acquisition" element={<MarketingAcquisitionBuildersPage />} />
            <Route path="/marketing/media" element={<MarketingMediaLibraryPage />} />
            <Route path="/marketing/copilot" element={<MarketingCopilotPage />} />
            <Route path="/marketing/segments" element={<MarketingSegmentsPage />} />
            <Route path="/marketing/journeys" element={<MarketingJourneysPage />} />
            <Route path="/marketing/templates" element={<MarketingTemplatesPage />} />
            <Route path="/marketing/lifecycle" element={<MarketingLifecyclePage />} />
            <Route path="/marketing/reports" element={<MarketingReportsPage />} />
            <Route path="/marketing/suppression" element={<MarketingSuppressionPage />} />
            <Route path="/marketing/webhooks" element={<MarketingEspWebhooksPage />} />
            <Route path="/crm/analytics" element={<Navigate to="/crm/reports" replace />} />
            <Route path="/crm/reports" element={<CrmReportsPage />} />
            <Route path="/crm/setup" element={<CrmSetupPage />} />
            <Route path="/crm/setup/oauth/google/callback" element={<CrmGoogleOAuthCallbackPage />} />
            <Route path="/crm/settings" element={<Navigate to="/crm/setup" replace />} />
            <Route path="/social" element={<SocialDashboardPage />} />
            <Route path="/social/inbox" element={<SocialInboxPage />} />
            <Route path="/social/messenger" element={<SocialMessengerPage />} />
            <Route path="/social/workflows" element={<SocialWorkflowBuilderPage />} />
            <Route path="/social/publishing" element={<SocialPublishingCenterPage />} />
            <Route path="/social/calendar" element={<SocialCalendarPage />} />
            <Route path="/social/media" element={<SocialMediaLibraryPage />} />
            <Route path="/social/analytics" element={<SocialAnalyticsCenterPage />} />
            <Route path="/social/automation" element={<SocialAutomationPage />} />
            <Route path="/social/crm-leads" element={<SocialCrmLeadsPage />} />
            <Route path="/social/teams" element={<SocialTeamsPage />} />
            <Route path="/social/connect" element={<SocialConnectionCenterPage />} />
            <Route path="/social/connect/add" element={<ConnectPlatformPickerPage />} />
            <Route path="/social/connect/add/:platformId" element={<PlatformConnectFlowPage />} />
            <Route path="/social/connect/guide/:platformId" element={<SetupGuidePlatformRedirect />} />
            <Route path="/social/setup-guide" element={<SetupGuideHubPage />} />
            <Route path="/social/executive" element={<SocialExecutiveDashboardPage />} />
            <Route path="/social/settings" element={<SocialSettingsLegacyRedirect />} />
            <Route path="/social/comments" element={<SocialCommentsHubPage />} />
            <Route path="/social/platforms" element={<SocialPlatformsHubPage />} />
            <Route path="/social/platforms/:platformId" element={<PlatformWorkspacePage />} />
            <Route path="/social/platforms/:platformId/:tab" element={<PlatformWorkspacePage />} />
            <Route path="/social/channels" element={<SocialChannelsRedirect />} />
            <Route path="/social/listening" element={<SocialListeningPage />} />
            <Route path="/social/campaigns" element={<SocialCampaignsPage />} />
            <Route path="/social/whatsapp/campaigns" element={<CampaignsPage />} />
            <Route path="/social/whatsapp/campaigns/new" element={<CampaignBuilderPage />} />
            <Route path="/social/whatsapp/campaigns/compare" element={<CampaignComparePage />} />
            <Route path="/social/whatsapp/campaigns/:campaignId" element={<CampaignDetailPage />} />
            <Route path="/social/whatsapp/bulk-queues" element={<BulkQueueMonitorPage />} />
            <Route path="/social/whatsapp/bulk-queues/failed" element={<FailedQueuePage />} />
            <Route path="/social/whatsapp/schedules" element={<ScheduledMessagesPage />} />
            <Route path="/social/whatsapp/schedules/new" element={<ScheduleEditorPage />} />
            <Route path="/social/whatsapp/schedules/:scheduleId/edit" element={<ScheduleEditorPage />} />
            <Route path="/social/whatsapp/sync" element={<WhatsAppSyncCenterPage />} />
            <Route path="/social/whatsapp/settings" element={<WhatsAppSettingsPage />} />
            <Route path="/social/whatsapp/automations" element={<WhatsAppAutomationPage />} />
            <Route path="/social/whatsapp/inbox" element={<TeamInboxAdminPage />} />
            <Route path="/social/whatsapp/reports" element={<WhatsAppReportsPage />} />
            <Route path="/social/whatsapp/reports/jobs" element={<ReportJobsPage />} />
            <Route path="/social/whatsapp/reports/builder/:code" element={<ReportBuilderPage />} />
            <Route path="/social/whatsapp/audit" element={<WhatsAppAuditPage />} />
            <Route path="/social/whatsapp/integrations" element={<WhatsAppIntegrationsPage />} />
            <Route path="/social/whatsapp/knowledge-base" element={<WhatsAppKnowledgeBasePage />} />
            <Route path="/social/whatsapp/surveys" element={<WhatsAppSurveysPage />} />
            <Route path="/social/reviews" element={<SocialReviewsPage />} />
            <Route path="/social/reports" element={<Navigate to="/social/analytics" replace />} />
            <Route path="/social/setup" element={<Navigate to="/settings/communication/social-settings" replace />} />
            <Route path="/social/approvals" element={<ApprovalsInboxPage />} />
            <Route path="/social/webhooks" element={<Navigate to="/settings/communication/social-webhooks" replace />} />
            <Route path="/hr" element={<HrDashboardPage />} />
            <Route path="/hr/employees" element={<HrEmployee360Page />} />
            <Route path="/hr/employees/:employeeId" element={<HrEmployee360Page />} />
            <Route path="/hr/attendance" element={<HrAttendancePage />} />
            <Route path="/hr/timesheet" element={<HrTimesheetPage />} />
            <Route path="/hr/leaves" element={<HrLeavesPage />} />
            <Route path="/hr/master-data" element={<HrMasterDataPage />} />
            <Route path="/hr/leave-policies" element={<HrLeavePoliciesPage />} />
            <Route path="/hr/shifts" element={<HrShiftsPage />} />
            <Route path="/hr/overtime" element={<HrOvertimePage />} />
            <Route path="/hr/onboarding" element={<HrOnboardingPage />} />
            <Route path="/hr/documents" element={<HrDocumentsPage />} />
            <Route path="/hr/allowances" element={<Navigate to="/settings/compensation-benefits/allowance-types" replace />} />
            <Route path="/hr/compensation" element={<Navigate to="/hr/payroll" replace />} />
            <Route path="/hr/travel" element={<HrTravelPage />} />
            <Route path="/hr/succession" element={<HrSuccessionPage />} />
            <Route path="/hr/admin" element={<HrAdminConfigPage />} />
            <Route path="/hr/payroll" element={<HrPayrollPage />} />
            <Route path="/hr/statutory" element={<HrStatutoryPage />} />
            <Route path="/hr/ess" element={<HrEssPortalPage />} />
            <Route path="/hr/recruitment" element={<HrRecruitmentPage />} />
            <Route path="/hr/appraisal" element={<HrAppraisalPage />} />
            <Route path="/hr/loans" element={<HrLoansPage />} />
            <Route path="/hr/asset-requests" element={<Navigate to="/hr/master-data?tab=assetRequests" replace />} />
            <Route path="/hr/feedback360" element={<HrFeedback360Page />} />
            <Route path="/hr/devices" element={<HrDevicesPage />} />
            <Route path="/hr/claims" element={<HrClaimsPage />} />
            <Route path="/hr/training" element={<HrTrainingPage />} />
            <Route path="/hr/reports" element={<HrReportsPage />} />
            <Route path="/hr/workflows" element={<HrWorkflowsPage />} />
            <Route path="/hr/org" element={<HrOrgStructurePage />} />
            <Route path="/hr/mss" element={<HrMssPortalPage />} />
            <Route path="/hr/holidays" element={<HrHolidaysPage />} />
            <Route path="/hr/setup" element={<HrSetupPage />} />
            <Route path="/hr/settings" element={<Navigate to="/hr/setup" replace />} />
            <Route path="/desk" element={<DeskDashboardPage />} />
            <Route path="/desk/workspace" element={<DeskWorkspacePage />} />
            <Route path="/desk/tickets" element={<DeskTicketsPage />} />
            <Route path="/desk/tickets/:ticketId" element={<DeskTicketDetailPage />} />
            <Route path="/desk/support-360/:customerId" element={<CustomerSupport360Page />} />
            <Route path="/desk/inbox" element={<DeskInboxPage />} />
            <Route path="/desk/livechat" element={<DeskLiveChatPage />} />
            <Route path="/desk/projects" element={<Navigate to="/projects" replace />} />
            <Route path="/desk/boards" element={<DeskBoardsPage />} />
            <Route path="/desk/knowledgebase" element={<DeskKnowledgeBasePage />} />
            <Route path="/desk/reports" element={<DeskReportsPage />} />
            <Route path="/desk/automation" element={<DeskAutomationPage />} />
            <Route path="/desk/setup/workflows" element={<DeskWorkflowDesignerPage />} />
            <Route path="/desk/canned-responses" element={<DeskCannedResponsesPage />} />
            <Route path="/desk/setup" element={<DeskSetupPage />} />
            <Route path="/desk/settings" element={<Navigate to="/desk/setup" replace />} />
            <Route path="/finance" element={<FinanceDashboardPage />} />
            <Route path="/finance/receivables" element={<FinanceReceivablesWorkspacePage />} />
            <Route path="/finance/payables" element={<FinancePayablesWorkspacePage />} />
            <Route path="/finance/payables/ap" element={<FinanceApPage />} />
            <Route path="/finance/tax" element={<FinanceTaxWorkspacePage />} />
            <Route path="/finance/control" element={<FinanceAdministrationWorkspacePage />} />
            <Route path="/finance/setup/wizard" element={<FinanceSetupWizardPage />} />
            <Route path="/finance/health" element={<FinanceHealthCenterPage />} />
            <Route path="/finance/close" element={<FinanceCloseCenterPage />} />
            <Route path="/finance/control/rules" element={<FinanceBusinessRulesPage />} />
            <Route path="/finance/treasury/forecast" element={<FinanceCashForecastPage />} />
            <Route path="/finance/collections" element={<FinanceCollectionsCenterPage />} />
            <Route path="/finance/automation" element={<FinanceAutomationPage />} />
            <Route path="/finance/analytics" element={<FinanceAnalyticsPage />} />
            <Route path="/finance/compliance" element={<FinanceCompliancePage />} />
            <Route path="/finance/audit" element={<FinanceAuditTrailPage />} />
            <Route path="/finance/documents" element={<FinanceDocumentCapturePage />} />
            <Route path="/finance/integrations" element={<FinanceIntegrationsPage />} />
            <Route path="/finance/accounting" element={<FinanceAccountingPage />} />
            <Route path="/finance/ledger" element={<FinanceLedgerPage />} />
            <Route path="/finance/invoices" element={<FinanceInvoicesPage />} />
            <Route path="/finance/payments" element={<FinancePaymentsPage />} />
            <Route path="/finance/banking" element={<FinanceBankingPage />} />
            <Route path="/finance/taxes" element={<FinanceTaxesPage />} />
            <Route path="/finance/expenses" element={<FinanceExpensesPage />} />
            <Route path="/finance/assets" element={<FinanceAssetsPage />} />
            <Route path="/finance/budgets" element={<FinanceBudgetsPage />} />
            <Route path="/finance/treasury" element={<FinanceTreasuryPage />} />
            <Route path="/finance/revenue" element={<FinanceRevenuePage />} />
            <Route path="/finance/workflows" element={<FinanceWorkflowsPage />} />
            <Route path="/finance/workflows/designer" element={<FinanceWorkflowDesignerPage />} />
            <Route path="/finance/reports" element={<FinanceReportsPage />} />
            <Route path="/finance/reports/builder" element={<FinanceReportBuilderPage />} />
            <Route path="/finance/setup" element={<FinanceSetupPage />} />
            <Route path="/finance/settings" element={<Navigate to="/finance/setup" replace />} />
            <Route path="/projects" element={<ProjectsDashboardPage />} />
            <Route path="/projects/list" element={<ProjectsListPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/projects/tasks" element={<ProjectsTasksPage />} />
            <Route path="/projects/boards" element={<ProjectsBoardsPage />} />
            <Route path="/projects/sprints" element={<ProjectsSprintsPage />} />
            <Route path="/projects/timesheets" element={<ProjectsTimesheetsPage />} />
            <Route path="/projects/portfolio" element={<ProjectsPortfolioPage />} />
            <Route path="/projects/issues" element={<ProjectsIssuesPage />} />
            <Route path="/projects/gantt" element={<ProjectsGanttPage />} />
            <Route path="/projects/resources" element={<ProjectsResourcesPage />} />
            <Route path="/warehouse/mobile" element={<WmsMobilePage />} />
            <Route path="/projects/calendar" element={<ProjectsCalendarPage />} />
            <Route path="/projects/workload" element={<ProjectsWorkloadPage />} />
            <Route path="/projects/reports" element={<ProjectsReportsPage />} />
            <Route path="/projects/automation" element={<ProjectsAutomationPage />} />
            <Route path="/projects/setup" element={<ProjectsSetupPage />} />
            <Route path="/projects/settings" element={<Navigate to="/projects/setup" replace />} />
            <Route path="/pos/discounts" element={<DiscountsPage />} />
            <Route path="/pos/reports" element={<ReportsPage />} />
            {ALL_LEGACY_ORG_REDIRECTS.map(({ fromPrefix, toPrefix }) => (
              <Route key={`legacy-${fromPrefix}`}>
                <Route path={fromPrefix} element={<Navigate to={toPrefix} replace />} />
                <Route
                  path={`${fromPrefix}/*`}
                  element={<LegacyModulePathRedirect fromPrefix={fromPrefix} toPrefix={toPrefix} />}
                />
              </Route>
            ))}
            <Route path="*" element={<WorkspaceNotFoundHandler />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<PosLayout />}>
            <Route path="/pos" element={<PosPage />} />
            <Route path="/pos/held" element={<HeldBillsPage />} />
            <Route path="/pos/shift" element={<PosShiftPage />} />
            <Route path="/pos/returns" element={<PosReturnsPage />} />
            <Route path="/pos/analytics" element={<PosAnalyticsDashboard />} />
            <Route path="/pos/setup" element={<PosSetupPage />} />
            <Route path="/pos/terminal-reports" element={<PosReportsPage />} />
          </Route>
        </Route>
        </Route>

        <Route path="*" element={<UnknownRouteHandler />} />
      </Routes>
      </Suspense>
      </RouteErrorBoundary>
    </BrowserRouter>
  );
}

